import React from 'react'

const Step5 = () => {
  return (
    <div>Step5</div>
  )
}

export default Step5